import { getOutlookSpaces } from '../service';
import { loadSummaries } from '../actions';
import { orchestrator, mutatorAction } from 'satcheljs';
import { setProjects } from '../privateActions';
import { errorThatWillCauseAlert, TraceErrorObject } from 'owa-trace';
import getStore from '../store';
import isLoadingProjects from '../selectors/isLoadingProjects';
import { setDefaultProjectLoadState } from '../mutators/defaultProjectLoadStateMutators';
import { DefaultProjectLoadState } from '../schema/DefaultProjectLoadState';

orchestrator(loadSummaries, async ({ appName }) => {
    if (!isLoadingProjects()) {
        setLoadingSummariesError(null);
        setIsLoadingSummaries(true);
        try {
            // TODO: support querying the set of projects in known group mailboxes
            const sourceMailbox = '';
            const outlookSpaces = await getOutlookSpaces({ appName });
            setProjects(sourceMailbox, outlookSpaces, appName);
            setDefaultProjectLoadState(DefaultProjectLoadState.SuccessLoadExisting);
        } catch (e) {
            setLoadingSummariesError(e);
            setDefaultProjectLoadState(DefaultProjectLoadState.ErrorLoadExisting);
        } finally {
            setIsLoadingSummaries(false);
        }
    }
});

const setLoadingSummariesError = mutatorAction(
    'setLoadingSummariesError',
    (error: TraceErrorObject | null) => {
        if (error) {
            error.networkError = true;
            errorThatWillCauseAlert('Failed to load Outlook Spaces', error);
        }
        getStore().loadingProjectsFailed = !!error;
        getStore().loadingProjectsFailure = error?.message;
    }
);

const setIsLoadingSummaries = mutatorAction(
    'setIsLoadingSummaries',
    (isLoadingProjects: boolean) => {
        getStore().isLoadingProjects = isLoadingProjects;
    }
);
